import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDayRainShower: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M36.0658 32.7223C37.7658 28.689 40.5547 25.3112 43.977 22.7445C41.7436 18.5001 37.3436 15.5668 32.2103 15.5668C24.8436 15.5668 18.877 21.5334 18.877 28.9001C18.877 33.0445 20.8103 36.7001 23.777 39.1445C26.877 35.7001 31.1881 33.3334 36.0658 32.7223Z"
        fill="#F9D23E"
      />
      <path
        d="M34.2207 2.2334H30.2207V12.2334H34.2207V2.2334Z"
        fill="#F9D23E"
      />
      <path
        d="M14.7761 8.63095L11.9473 11.4594L19.0183 18.5314L21.8471 15.703L14.7761 8.63095Z"
        fill="#F9D23E"
      />
      <path d="M15.5547 26.9H5.55469V30.9H15.5547V26.9Z" fill="#F9D23E" />
      <path
        d="M49.6618 8.63088L42.5918 15.7029L45.4206 18.5309L52.4906 11.4589L49.6618 8.63088Z"
        fill="#F9D23E"
      />
      <path
        d="M21.6995 41.9445L19.0217 39.2778L11.9551 46.3445L14.7773 49.1778L21.3884 42.5667L21.8551 42.1001L21.6995 41.9445Z"
        fill="#F9D23E"
      />
      <path
        d="M52.4541 71.1001L42.8652 97.7668H47.5875L57.1763 71.1001H52.4541Z"
        fill="#87D6F8"
      />
      <path
        d="M62.1319 71.1001L52.543 97.7668H57.2763L66.8541 71.1001H62.1319Z"
        fill="#87D6F8"
      />
      <path
        d="M71.8096 71.1001L62.2207 97.7668H66.954L76.5429 71.1001H71.8096Z"
        fill="#87D6F8"
      />
      <path
        d="M42.9206 71.1001L38.0762 84.4334H42.7984L47.6539 71.1001H42.9206Z"
        fill="#87D6F8"
      />
      <path
        d="M84.2882 46.889H79.2104V41.9445C79.2104 31.0334 70.1104 22.189 58.8882 22.189C53.666 22.189 48.9771 24.1556 45.3993 27.3112C42.4993 29.8667 40.3104 33.189 39.2993 37.0001H38.5771C34.3438 37.0001 30.5104 38.689 27.7549 41.4001C25.0326 44.0779 23.3438 47.7556 23.3438 51.8112C23.3438 59.989 30.166 66.6223 38.5771 66.6223H43.6549H74.1326H84.2882C89.8993 66.6223 94.4438 62.2001 94.4438 56.7445C94.4438 51.3112 89.8993 46.889 84.2882 46.889Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconDayRainShower
